import { Box, Typography } from "@mui/material";

interface TfcBannerBoxProps {
  borderColor: string;
  backgroundColor: string;
  children: React.ReactNode;
}

export function TfcBannerBox(props: TfcBannerBoxProps) {
  const { borderColor, backgroundColor, children } = props;
  return (
    <Box
      sx={{
        borderLeft: `4px solid ${borderColor}`,
        backgroundColor,
        borderRadius: "4px",
        p: 2,
        mb: 3,
      }}
    >
      <Typography sx={{ fontSize: "14px", color: "#000000" }}>
        {children}
      </Typography>
    </Box>
  );
}
